import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { createUploadLink } from "./graphql-upload-link";
import { setContext } from '@apollo/client/link/context';
import { BASE_API_URL } from "./ApiUrls";
import { RECAPTCHA_HEADER_KEY } from "./Constants";
import RecaptchaTokenResolver from "./RecaptchaTokenResolver";

export default function configureGraphQL(store) {
    const httpLink = createUploadLink({
        uri: `${BASE_API_URL}graphql`,
        //useGETForQueries: true
    });

    const authLink = setContext(async (operation, { headers }) => {
        // get the authentication token from local storage if it exists
        const token = (store.getState().login.auth || {}).token;

        const _headers = {
            ...headers,
            authorization: token ? `Bearer ${token}` : ""
        };
        if (operation.query.definitions.some(a => a.kind === 'OperationDefinition' &&  a.operation === "mutation")) {
            const r_token = await RecaptchaTokenResolver();
            _headers[RECAPTCHA_HEADER_KEY] = r_token;
        }
        // return the headers to the context so httpLink can read them
        return {
            headers: _headers
        };
    });

    //function pagedListPagination(keyArgs) {
    //    return {
    //        keyArgs: [],
    //        merge: (existing = {items = []}, incoming) => {
    //            const { items, ...rest } = incoming;
    //            let data = { ...existing, ...rest };
    //            data.items = [...data.items, ...items];
    //        },
    //        read: (existing, { args: { page = 1, pageSize = 10 } } = {}) => {
    //            const offset = (page - 1) * pageSize;
    //            const { items, ...rest } = existing;
    //            let data = { ...existing, ...rest };
    //            return existing && existing.slice(offset, offset + pageSize);
    //        }
    //    }
    //}

    const cache = new InMemoryCache();

    const client = new ApolloClient({
        link: authLink.concat(httpLink),
        cache: cache
    });

    return client;
}


// WEBPACK FOOTER //
// ./src/common/configureGraphQL.js